// src/components/CookieBanner.js
import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (!accepted) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: "#333",
        color: "#fff",
        p: 2,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300,
      }}
    >
      <Typography
        variant="body1"
        sx={{
          fontFamily: "'Bebas Neue', sans-serif",
          mr: { sm: 2 },
          mb: { xs: 1, sm: 0 },
          textAlign: "center",
        }}
      >
        Este sitio utiliza cookies para mejorar su experiencia.{" "}
        <Link
          component={RouterLink}
          to="/politica-cookies"
          sx={{ color: "#fff", textDecoration: "underline" }}
        >
          Más información
        </Link>
      </Typography>
      <Button variant="contained" color="primary" onClick={handleAccept}>
        Aceptar
      </Button>
    </Box>
  );
};

export default CookieBanner;
